const AccuCodeService = [
    "$cookies",
    function ($cookies) {
        function getAccuCode() {
            return $cookies.get("accu");
        }
        return {
            getAccuCode: getAccuCode
        };
    }
];
export default AccuCodeService;
